export default "__VITE_ASSET__oOkSH5Nu__"